/**
 * M · A · E · W circles: grey until an attempt fills that time window for non-service, then green.
 * M 6 AM–noon, A noon–6 PM, E 6–10 PM (a full day apart), W any time Saturday (no spacing needed).
 * 3 of 4 green → non-service can be finalized. Rule to Vacate shows its own timing instead.
 * The door hanger icon is green once a hanger has been left on this paper.
 */
const when = (d: Date | string) => new Date(d).toLocaleString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export function ServiceCircles({ ev, compact = false }: { ev: any; compact?: boolean }) {
  if (!ev) return null;
  const hanger = (
    <span className={`dh-ico ${ev.doorHanger ? 'on' : ''}`} title={ev.doorHanger ? 'Door hanger left' : 'No door hanger left yet'} aria-label={ev.doorHanger ? 'Door hanger left' : 'No door hanger left'}>
      <svg viewBox="0 0 16 22" width="12" height="17" aria-hidden="true">
        <path d="M2 1h12v20H2z" fill="currentColor" rx="2" />
        <circle cx="8" cy="5" r="2.6" fill="#fff" />
        <path d="M5.4 5 5.4 1.2M10.6 5 10.6 1.2" stroke="#fff" strokeWidth="1.2" />
      </svg>
    </span>
  );
  if (ev.vacate) {
    return (
      <span className={`svc-line vacate ${ev.vacate.eligibleNow ? 'ok' : ''}`}>
        <span className="vac-text">{ev.vacate.text}</span>
        {hanger}
      </span>
    );
  }
  const w = ev.windows;
  if (!w) return <span className="svc-line">{hanger}</span>;
  return (
    <span className={`svc-line ${compact ? 'compact' : ''}`} aria-label={`${w.green} of ${w.slots.length} time windows fulfilled; ${w.needed} needed for non-service`}>
      {w.slots.map((s: any) => (
        <span key={s.id} className={`svc-c ${s.attemptId ? 'on' : ''}`} title={s.attemptId ? `${s.label}: ${when(s.at)}` : `${s.label}: not yet`}>
          {s.letter}
        </span>
      ))}
      {hanger}
      {w.satisfied && <span className="svc-ok">Non-service ready</span>}
    </span>
  );
}
